<template>
  <div class="full-width column wrap items-center">
    <!-- <div class="col-12 q-mb-lg" v-if="showBannerImage">
        <img class="image-banner" :src="calculatorBannerImage" />
      </div> -->
    <div class="header-container q-my-lg" v-if="showHeaderContainer">
      <h4 class="header-title">{{ getContentTitle }}</h4>
      <div class="header-subtitle q-ma-md" v-html="getContentText"></div>
    </div>
    <div class="stepper-header-container q-mb-md" v-if="user === null">
      <h4 class="stepper-header-title" v-if="isFirstStep">Choose your vehicle</h4>
      <h4 class="stepper-header-title" v-else-if="pathName == '/calculator/results'">Vehicle results</h4>
      <h4 class="stepper-header-title" v-else-if="pathName == '/calculator/shortlists'">Your shortlisted vehicles</h4>
      <h4 class="stepper-header-title" v-else-if="pathName == '/calculator/enquire-now'">{{ enquireNowHeader }}</h4>
    </div>

    <router-view class="full-width q-pa-sm" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import calculatorBanner from '../../../public/assets/images/calculatorHeaderBanner.png';
import { vehicleSearchConfigMixin } from '../../mixins/calculator';

export default {
  name: 'CalculatorPage',
  mixins: [vehicleSearchConfigMixin],
  data() {
    return {
      currentStep: 0,
      calculatorComponents: [
        { title: 'Step 1. Choose your vehicle', icon: '1', route: '/calculator' },
        { title: 'Step 2. Vehicle results', icon: '2', route: '/calculator/results' },
        { title: 'Step 3. Your shortlisted vehicles', icon: '3', route: '/calculator/shortlists' }
      ]
    };
  },
  async mounted() {
    window.scrollTo(0, 0);

    if (['vehicleProduct'].includes(this.$route?.name)) {
      this.fetchVehicleSearchConfig(false);
    } else {
      await this.fetchVehicleSearchConfig();
    }
  },
  watch: {
    '$route.path'(newPath, oldPath) {
      if (newPath !== oldPath) {
        this.currentStep = this.getCurrentStep();
        window.scrollTo(0, 0);
      }
    }
  },
  created() {
    this.calculatorBannerImage = calculatorBanner;
    this.currentStep = this.getCurrentStep();
  },
  computed: {
    ...mapGetters({
      calculator: 'theme/getCalculator',
      isNZ: 'theme/isNZ'
    }),
    user: function () {
      return this.$store.getters['auth/user'];
    },
    pathName: function () {
      return this.$route.path;
    },
    isFirstStep: function () {
      return ['/calculator/search', '/calculator/', '/calculator'].some((path) => path === this.pathName);
    },
    showBannerImage: function () {
      const bannerImagePath = ['/calculator', '/calculator/search', '/calculator/thank-you'];
      return bannerImagePath.some((path) => path === this.pathName);
    },
    showHeaderContainer: function () {
      const path = ['/calculator', '/calculator/'];
      return path.some((path) => path === this.pathName);
    },
    getContentTitle() {
      const contentTitleNZ = 'Quickly calculate your business vehicle lease cost!';
      const contentTitleAU = 'Business leasing calculator';

      if (this.calculator?.contentTitle) {
        return this.calculator.contentTitle;
      }

      return this.isNZ ? contentTitleNZ : contentTitleAU;
    },
    enquireNowHeader() {
      return this.calculator?.enquireNowHeader_Disabled || 'Enquire now';
    },
    getContentText() {
      if (this.calculator?.contentText) {
        return this.calculator.contentText;
      }

      const contentTextNZ = `<p>
          Whether you need 1 or 30 vehicles for your business, a Fully Maintained Operating Lease by FleetPartners means there are no
          upfront costs and a single monthly payment that includes scheduled servicing, maintenance, replacement tyres, 24/7 roadside
          assistance, and WOF. Plus, we’ll take care of the ongoing and time-consuming vehicle administration related to accident
          management, fuel, tolls, as well as annual re-registration. You’ll get the vehicles you need to keep your business moving while
          knowing exactly what you’re spending each month, helping to keep your cashflow in check.
        </p>
        <p>
          In less than 2 minutes, you can choose, compare and shortlist vehicles and get obligation-free business operating lease
          estimates.*
        </p>`;

      const contentTextAU = `<p>
          Whether you need 1 or 20 vehicles for your business, an Operating Lease by FleetPartners means there are no major upfront costs
          and a single monthly payment that includes schedule servicing, maintenance, replacement tyres, 24/7 roadside assistance, and more.
          Plus, we’ll take care of the ongoing and time-consuming vehicle administration such as accident, fuel, tolls, infringement
          management, as well as annual re-registration. You’ll get the vehicles you need to keep your business moving while knowing exactly
          what you’re spending each month, helping to keep your cashflow in-check.
        </p>
        <p>
          Choose, compare and shortlist vehicles, and get an obligation-free business Operating Lease quote estimate in less than 2 minutes.
        </p>
        <p>
          To be eligible, you’ll need an ABN that’s been active for 2 or more years and is registered for GST with an annual turnover of
          more than $125,000.
        </p>`;

      return this.isNZ ? contentTextNZ : contentTextAU;
    },
    showStepper: function () {
      const stepperPath = ['/calculator', '/calculator/', '/calculator/search', '/calculator/results', '/calculator/shortlists'];
      return stepperPath.some((path) => path === this.pathName);
    }
  },
  methods: {
    getCurrentStep() {
      const stepIndex = this.calculatorComponents.findIndex(({ route }) => route === this.pathName || `${route}/` === this.pathName);
      return stepIndex >= 0 ? stepIndex + 1 : stepIndex;
    }
  },
  components: {}
};
</script>

<style lang="sass" scoped>
.stepper-container
  background: transparent
  width: 100%
  max-width: 335px
.header-container
  max-width: 1052px
  text-align: center
.header-subtitle
  font-size: 15px
  line-height: 19.5px

.stepper-header-title, .header-title
  color: $primary
  font-size: 32px
.image-banner
  width: 100%
  object-fit: contain
@media (max-width:768px)
  .stepper-header-title, .header-title
    font-size: 24px
</style>
